import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import {
	GoogleAddressResponse,
	ItemPopover,
	ItemPopoverService,
	PlacesResponse,
	PopoverResponseMap,
	SearchAdvancedCountry
} from '@interfaces'
import { catchError, map, Observable } from 'rxjs'
import { Country, CountryServerResponse } from '../interfaces/CountryMultiselector.interface'
import { normalizeRemoteSearchStringParam } from './remote-text-search.helper'

@Injectable({
	providedIn: 'root'
})
export class PlaceService implements ItemPopoverService {
	private http = inject(HttpClient)
	url = '/google-maps/places/'

	// Devuelve el id del lugar
	getPlaceId(placesId: string): Observable<PlacesResponse> {
		return this.http.get<PlacesResponse>(`/google-maps/places/${placesId}`)
	}

	// Devuelve los posibles lugares coincidentes
	getPlaces(searchTerm: string): Observable<GoogleAddressResponse[]> {
		return this.http.get<GoogleAddressResponse[]>(`${this.url}autocomplete/${searchTerm}`)
	}

	// Recoge los paises paginados
	getCountries(body: SearchAdvancedCountry): Observable<CountryServerResponse> {
		let url = `/countries`

		if (body.continent && body.continent.length > 0) {
			// url += `&continentIds=${body.continent.join(',')}`
		}
		return this.http.post<CountryServerResponse>(url, body)
	}

	// Recoge los paises disponibles
	getAllCountries(): Observable<Country[]> {
		return this.http.get<Country[]>('/countries')
	}

	getItemPopoverData(
		page: number,
		size: number,
		_type?: string,
		params?: { [key: string]: any }
	): Observable<PopoverResponseMap> {
		const body: SearchAdvancedCountry = {
			...params,
			page,
			size,
			active: true,
			searchString: normalizeRemoteSearchStringParam(params?.searchString)
		}

		return this.getCountries(body).pipe(
			map(response => ({
				...response,
				content: response.content.map(
					({ id, isoCode, translations }): ItemPopover => ({
						id: id,
						value: translations[0]?.name || isoCode,
						key: typeof isoCode === 'string' ? isoCode.toUpperCase() : undefined,
						active: false
					})
				)
			}))
		)
	}

	getCountry(lat?: number, lng?: number): Observable<string | null> {
		const body = {
			lat,
			lng
		}
		const url = '/google-maps/geolocation'

		return this.http.post<any>(url, body).pipe(
			map(response => {
				if (response.status === 'OK' && response.results.length > 0) {
					const addressComponents = response.results[0].address_components

					const countryComponent = addressComponents.find((component: { types: string | string[] }) =>
						component.types.includes('country')
					)

					console.log('Conectado desde: ' + (countryComponent ? countryComponent.long_name : null))
					return countryComponent
				}
				return null
			}),
			catchError(err => {
				console.error('Error fetching country', err)
				return [null] // Devuelve null en caso de error
			})
		)
	}
}
